import axios from 'axios'
import moment from 'moment'
import {
	OPEN_MODAL,
	CLOSE_MODAL,
	PAGE_TITLE_CHANGED,
} from './types'

import { API_URL } from '../api'

export function errorHandler(error) {
	if (typeof error !== 'undefined') {
		switch (error.status) {
			case 401:
				return 'Hmm. Those details don\'t seem right.'
			case 500:
				return 'Yikes! Something seems to have gone wrong.'
			default:
				return 'An error occured, please try again.'
		}
	}
}

export const openModal = (operation, dataType, data) => {
	return dispatch => {
		dispatch({
			type: OPEN_MODAL,
			operation,
			dataType,
			data
		})
	}
}

export function closeModal() {
	return dispatch => {
		dispatch({
			type: CLOSE_MODAL
		});
	}
}

export function deleteItem(itemType, item, account, callback = null, stateOnly = false) {
	return dispatch => {
		dispatch({
			type: 'ENTITY_DELETED',
			entityType: itemType,
			payload: item,
			stateOnly
		})

		callback && callback(itemType)

		if(!stateOnly){
			axios.post(API_URL + '/deleteItem', { data: { type: itemType, id: item.id, item: item, account: account } }).then(response => {
				// moved dispatch out of here.
			}).catch(error => {
				console.log(error);
				//errorHandler(dispatch, error.response, AUTH_ERROR);
			});
		}
	}
}

export function saveItem(data, type, callback) {
	return dispatch => {
		axios.post(`${API_URL}/${type}s/save`, { data, type }).then(response => {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data,
				entityType: type,
			})

			// this is temporary. I needa split up saveItem
			if (type == 'project') {
				dispatch({
					type: 'project_updated',
					payload: response.data.id
				})
			}

			if (typeof callback !== 'undefined') {
				callback(response.data)
			}
		}).catch(error => {
			console.log(error)
		});
	}
}

export function changeTitle(title, flash = null) {
	return dispatch => {
		document.title = title + ' - Hassl.'

		if (!flash) {
			dispatch({
				type: PAGE_TITLE_CHANGED,
				payload: title
			});
		}
	}
}

export const loadMore = (type, id, offset, callback) => {
	return dispatch => {
		axios.post(API_URL + '/accounts/loadMore', { type, id, offset }).then(response => {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data.activityItems,
				entityType: 'activity',
				isArray: true
			})

			callback(response.data.hasMore)
		}).catch(error => {
			console.log(error)
		})
	}

}

export const getMissingEntities = (entities, callback) => {
	return dispatch => {
		axios.post(API_URL+'/project/getMissing', { entities })
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'missing',
				})

				if(callback){
					callback()
				}
			})
			.catch(error => {
				console.log(error)
			})
	}
}

export const getActivityForDay = (projectId, day, callback) => {
	return dispatch => {
		axios.get(`${API_URL}/projects/activityByDay/${projectId}?day=${day}`)
			.then(response => {
				dispatch({
					type: 'project_got_data',
					payload: response.data,
					entityType: 'project',
				})

				if(callback){
					callback()
				}
			}).catch(error => {
				console.log(error)
			})
	}
}

export const getPlanAndCurrencyInfo = (callback = null) => {
	return dispatch => {
		axios.get(API_URL+'/currencyInfo')
			.then(response => {
				const responseData = response.data

				const authorizationHeader = axios.defaults.headers.common['Authorization']
				const socketHeader = axios.defaults.headers.common['X-Socket-ID']
				delete axios.defaults.headers.common['Authorization']
				delete axios.defaults.headers.common['X-Socket-ID']
		
				axios({
					method: 'post',
					url: 'https://hassl.yourcreative.com.au/ajax-plan-array',
					config: {
						headers: {
						  'Access-Control-Allow-Origin': '*',
						},
						withCredentials: false,
					},
					withCredentials: false,
				}).then(response => {
					let responseString = response.data
		
					const parsedResponse = responseString.substring(responseString.indexOf("["))
					const packages = JSON.parse(parsedResponse)

					responseData.planData = packages

					dispatch({
						type: 'PLAN_AND_CURRENCY_OBTAINED',
						payload: responseData
					})

					if(callback){
						callback(responseData)
					}
				})
		
				axios.defaults.headers.common['Authorization'] = authorizationHeader
				axios.defaults.headers.common['X-Socket-ID'] = socketHeader
			}).catch(error => {
				console.log(error)
			})
	}
}

export const getWellness = user => {
	if(!user){
		return null
	}
	
	return dispatch => {
		const formData = new FormData
		formData.append('action', 'get_wellness')

		let seenWellnessIds = user.seen_wellness_ids ? [...user.seen_wellness_ids] : []

		const authorizationHeader = axios.defaults.headers.common['Authorization']
		const socketHeader = axios.defaults.headers.common['X-Socket-ID']
		delete axios.defaults.headers.common['Authorization']
		delete axios.defaults.headers.common['X-Socket-ID']

		axios.post('https://hassl.yourcreative.com.au/wp-admin/admin-ajax.php',formData).then(response => {
			const { data } = response

			const allIds = Object.keys(data)

			let wellnessIdToShow = null

			// If we've already checked today, just grab today's
			if(seenWellnessIds.length && user.last_wellness_check && moment(user.last_wellness_check).isSame(moment(), 'day')){
				wellnessIdToShow = seenWellnessIds[seenWellnessIds.length - 1]
			}else{
				const remainingWellnessIds = allIds.filter(_id => seenWellnessIds.indexOf(_id) === -1)

				if(remainingWellnessIds.length){
					// There's more to choose from
					wellnessIdToShow = remainingWellnessIds[0]

					seenWellnessIds.push(wellnessIdToShow)
				}else{
					wellnessIdToShow = allIds[0]

					// You've seen them all. Start again
					seenWellnessIds = [wellnessIdToShow]
				}
			}
			
			if(wellnessIdToShow){
				// Update last seen

				axios.post(API_URL+'/user/setLastSeenWellness', {
					date: moment().format('YYYY-MM-DD'),
					ids: seenWellnessIds
				})
				.then(response => {
					dispatch({
						type: 'ENTITY_ADDED_OR_UPDATED',
						payload: response.data,
						entityType: 'user',
					})
				}).catch(error => {
					console.log(error)
				})

				// Set wellness data
				const hour = moment().format('H')

				let thisSessionIndex = 0
	
				if(hour < 14){
					thisSessionIndex = 0
				}else{
					thisSessionIndex = 1
				}
				
				const { items } = data[wellnessIdToShow]

				dispatch({
					type: 'GOT_WELLNESS_DATA',
					payload: items[thisSessionIndex] || items[0]
				})
			}
		}).catch(error => {
			console.log(error)
		})
		
		axios.defaults.headers.common['Authorization'] = authorizationHeader
		axios.defaults.headers.common['X-Socket-ID'] = socketHeader
	}
}